import React from "react";

interface CreditLimitAdjustButtonsProps {
  currentValue: string;
  onChange: (newValue: string) => void; // eslint-disable-line no-unused-vars
  step?: number;
}

const CreditLimitAdjustButtons: React.FC<CreditLimitAdjustButtonsProps> = ({
  currentValue,
  onChange,
  step = 100,
}) => {
  const handleAdjust = (delta: number) => {
    const current = currentValue ? parseInt(currentValue, 10) : 0;
    const newValue = delta < 0 ? Math.max(0, current + delta) : current + delta;
    onChange(String(newValue));
  };

  return (
    <>
      <button
        type="button"
        onClick={() => handleAdjust(-step)}
        className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-700 whitespace-nowrap"
      >
        -{step}
      </button>
      <button
        type="button"
        onClick={() => handleAdjust(step)}
        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 whitespace-nowrap"
      >
        +{step}
      </button>
    </>
  );
};

export default CreditLimitAdjustButtons;
